export default __webpack_public_path__ + "static/media/no-img-selected.8bd4b01e.svg";